import { createContext } from 'react';

import type { CompanyFeatureFlags } from '../utils';

export const FeatureFlagsContext = createContext<Readonly<CompanyFeatureFlags> | undefined>(
  undefined,
);
